import React from 'react';
import { Box, useMediaQuery } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import { getPlannerMode } from 'redux/PlannerModeSlice';
import { HEADER_HEIGHT_V1 } from 'projectConstants';
import BuilderModeRevamp from 'pages/BuilderModeRevamp';
import BuilderMode from 'pages/BuilderMode';

import PlanPageScenario from './PlanPageScenario';

export interface Properties {
  flags: any;
}

const PlanPageDetailsOPZ = ({ flags }: Properties) => {
  const [isLaptop]: any = useMediaQuery('(max-width: 1024px)');

  const plannerMode = useSelector(getPlannerMode);

  const showBuilderMode = plannerMode && !isLaptop;
  // The revamped plan page brings its own theme/background and renders full-bleed
  const isBuilderModeV1 = flags.builderModeUiRevamp;
  return (
    <Box
      height={`calc(100vh - ${!flags?.uiRevamp ? HEADER_HEIGHT_V1 : '0px'})`}
      bg={'gradient.body'}
      padding={isLaptop ? 4 : ''}
      overflow='hidden'
      display='flex'
      flexDirection='column'
    >
      {showBuilderMode ? (
        isBuilderModeV1 ? (
          <BuilderModeRevamp />
        ) : (
          <BuilderMode />
        )
      ) : (
        <PlanPageScenario />
      )}
    </Box>
  );
};

export default withLDConsumer()(PlanPageDetailsOPZ);
